import New from '@apps/platform/admin/views/teams/new'
import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'

const mapPropsToPanel = (props, context) => ({
  title: 't(Active Teams)',
  collection: {
    endpoint: '/api/admin/platform/teams',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: TeamToken }
    ],
    empty: {
      icon: 'building-o',
      title: 't(No Teams)',
      text: 't(You have not yet created any teams)'
    },
    entity: 'team',
    defaultSort: { key: 'title', order: 'asc' },
    onClick: (record) => context.router.push(`/platform/teams/${record.id}`)
  },
  task: {
    svg: 'plus',
    modal: New
  }
})

export default Panel(null, mapPropsToPanel)
